import { useLocation, useNavigate } from 'react-router-dom';
import { FiHome, FiUsers, FiCheckSquare, FiDollarSign, FiUser } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const navigation = [
  { name: 'dashboard', icon: FiHome, href: '/' },
  { name: 'students', icon: FiUsers, href: '/students' },
  { name: 'attendance', icon: FiCheckSquare, href: '/attendance' },
  { name: 'fees', icon: FiDollarSign, href: '/fees' },
  { name: 'profile', icon: FiUser, href: '/profile' },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNavigation = (href: string) => {
    // Always navigate to the main list view when clicking students
    if (href === '/students') {
      navigate('/students');
      return;
    }
    navigate(href);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800">
      <div className="max-w-md mx-auto px-4">
        <div className="flex justify-around py-2">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <button
                key={item.name}
                onClick={() => handleNavigation(item.href)}
                className="relative flex flex-col items-center py-2 px-4 min-w-[72px]"
              >
                {isActive && (
                  <motion.div
                    layoutId="bottomNavIndicator"
                    className="absolute -top-0.5 w-8 h-1 bg-primary dark:bg-primary-400 rounded-full"
                    transition={{ type: "spring", stiffness: 500, damping: 30 }}
                  />
                )}
                <item.icon
                  className={`h-6 w-6 ${
                    isActive
                      ? 'text-primary dark:text-primary-400'
                      : 'text-gray-500 dark:text-gray-400'
                  }`}
                />
                <span
                  className={`mt-1 text-xs ${
                    isActive
                      ? 'text-primary dark:text-primary-400 font-medium'
                      : 'text-gray-500 dark:text-gray-400'
                  }`}
                >
                  {t(item.name)}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}